import axios from 'axios'
import { REPORT_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getManualPoints(page, store, startDate, endDate) {
    const params = {
        page,
        store,
        startDate,
        endDate,
    }
    const url = `${REPORT_URL}/manualpoints`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

//#region Report: BOX
export function getDailyBalance(page, store, selectedDate) {
    const params = {
        page,
        store,
        selectedDate,
    }
    const url = `${REPORT_URL}/dailybalance`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getEmployeesBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/employeesbalance`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getDetailedSells(startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        store,
    }

    const url = `${REPORT_URL}/detailedsells`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
//#endregion

//#region Report: BAlANCE
export function getCategorySellsBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/categorysells`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getReceiptSellsBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/receipttypesells`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getReceiptBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/sellsbyreceipttype`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getCategoryBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/sellsbycategory`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getPaymentDetailsBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store
    }

    const url = `${REPORT_URL}/paymenttypesells`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getDetailedSellsPaymentBalance(startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        store
    }

    const url = `${REPORT_URL}/detailedsellspayment`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getPaymentTypesBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/sellsbypaymenttype`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getServiceDetailsBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/servicesells`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getOfferDetailsBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/offersells`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getServiceNamesBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/sellsbyservice`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function getDaysBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/sellsbyday`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function getCustomersBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/sellsbycustomer`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function getProductDetailsBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/productsells`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function getProductNamesBalance(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/sellsbyproduct`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
//#endregion

//#region Report: STOCK MOVEMENT
export function getProductsIn(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/productsin`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function getInternalConsumption(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/internalconsumption`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function getRegularizations(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/regularizations`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function getProductsDevolutions(page, startDate, endDate, store) {
    const params = {
        startDate,
        endDate,
        page,
        store,
    }

    const url = `${REPORT_URL}/productsdevolutions`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function getInventory(page, storeId) {
    const params = {
        store_id: storeId,
        page
    }

    const url = `${REPORT_URL}/inventory`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
//#endregion


// WEBPACK FOOTER //
// ./src/service/report.js